module.exports = __webpack_public_path__ + "img/example7.c05b3ab8.jpg";